/*
  Sauna heater package.

  Keeps the sauna product page in step with the heater picker:
  - the headline price shows the selected sauna variant plus the selected heater
  - the product form carries the chosen heater so ol-campaign-offers.js can add
    the sauna and heater to the basket as one locked package
*/
(function () {
  'use strict';

  if (window.olSaunaPackageReady) return;
  window.olSaunaPackageReady = true;

  function formatWholeMoney(cents) {
    var value = formatMoney(cents);
    return value.replace(/\.00(?!\d)/, '');
  }

  function summaryRow(label, amount, extraClass) {
    var row = document.createElement('div');
    row.className = 'ol-sauna-heater__summary-row' + (extraClass ? ' ' + extraClass : '');
    var name = document.createElement('span');
    name.className = 'ol-sauna-heater__summary-label';
    name.textContent = label;
    var value = document.createElement('span');
    value.className = 'ol-sauna-heater__summary-amount';
    value.textContent = amount;
    row.appendChild(name);
    row.appendChild(value);
    return row;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.money_format) {
      // The theme's money format wraps the amount in a span and uses &pound;,
      // so keep only the text and turn entities back into characters.
      var decoder = document.createElement('textarea');
      decoder.innerHTML = String(window.Shopify.formatMoney(cents, window.theme.money_format)).replace(/<[^>]*>/g, '');
      return decoder.value;
    }
    var pounds = (Number(cents) || 0) / 100;
    return '£' + pounds.toLocaleString('en-GB', {
      minimumFractionDigits: pounds % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function readProductJson() {
    var node = document.getElementById('ProductJson-1');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function findVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
    }
    return null;
  }

  function setupPicker(picker) {
    var productId = picker.getAttribute('data-product-id');
    var form = picker.closest('form');
    var product = readProductJson();
    if (!form || !product) return;

    var inputs = picker.querySelectorAll('.ol-sauna-heater__input');
    var summary = picker.querySelector('[data-ol-sauna-heater-summary]');
    var addButton = form.querySelector('button[name="add"]');
    var variantSelect = form.querySelector('[name="id"]');
    var currentVariant = findVariant(product, variantSelect && variantSelect.value) || product.variants[0];

    form.setAttribute('data-ol-package-type', 'sauna');
    form.setAttribute('data-ol-campaign-form', 'true');

    function selectedInput() {
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked && !inputs[i].disabled) return inputs[i];
      }
      return null;
    }

    function render() {
      var heater = selectedInput();
      var saunaPrice = currentVariant ? Number(currentVariant.price) || 0 : 0;
      var heaterPrice = heater ? Number(heater.getAttribute('data-ol-heater-price')) || 0 : 0;
      var total = saunaPrice + heaterPrice;

      Array.prototype.forEach.call(inputs, function (input) {
        var choice = input.closest('.ol-sauna-heater__choice');
        if (choice) choice.classList.toggle('ol-offer-package__choice--selected', input === heater);
      });

      if (heater) {
        form.setAttribute('data-ol-gift-variant-id', heater.getAttribute('data-ol-heater-variant-id') || '');
        form.setAttribute('data-ol-gift-title', heater.getAttribute('data-ol-heater-title') || '');
      } else {
        form.removeAttribute('data-ol-gift-variant-id');
        form.removeAttribute('data-ol-gift-title');
      }

      var priceNodes = document.querySelectorAll('.js-product-' + productId + ' .js-product-price-number');
      Array.prototype.forEach.call(priceNodes, function (node) {
        node.innerHTML = '<span class="product-single__price-number"><span class="money">' + formatMoney(total) + '</span></span>';
      });
      // Each heater card shows the full package price (this sauna option + that heater).
      Array.prototype.forEach.call(inputs, function (input) {
        var card = input.closest('.ol-sauna-heater__choice');
        var priceNode = card && card.querySelector('[data-ol-heater-package-price]');
        if (!priceNode || card.classList.contains('ol-sauna-heater__choice--unavailable')) return;
        var cardHeaterPrice = Number(input.getAttribute('data-ol-heater-price')) || 0;
        priceNode.textContent = formatWholeMoney(saunaPrice + cardHeaterPrice);
      });
      // The sticky add-to-basket dock shows the package price too.
      var dockPrices = document.querySelectorAll('.dock-price');
      Array.prototype.forEach.call(dockPrices, function (node) {
        node.innerHTML = '<span class="money">' + formatMoney(total) + '</span>';
      });
      var compareNodes = document.querySelectorAll('.js-product-' + productId + ' .js-product-price-compare, .js-product-' + productId + ' .js-product-savings');
      Array.prototype.forEach.call(compareNodes, function (node) {
        node.style.display = 'none';
      });

      if (summary) {
        summary.textContent = '';
        if (heater) {
          var heaterChoice = heater.closest('.ol-sauna-heater__choice');
          var heaterTitleNode = heaterChoice && heaterChoice.querySelector('.ol-offer-package__choice-title');
          var heaterName = (heaterTitleNode && heaterTitleNode.textContent.trim()) || heater.getAttribute('data-ol-heater-title') || 'Heater';
          var saunaName = 'Sauna';
          if (currentVariant && currentVariant.title && currentVariant.title !== 'Default Title') {
            saunaName += ' (' + currentVariant.title.replace(/ \/ /g, ', ') + ')';
          }
          summary.appendChild(summaryRow(saunaName, formatMoney(saunaPrice), ''));
          summary.appendChild(summaryRow(heaterName, formatMoney(heaterPrice), ''));
          summary.appendChild(summaryRow('Package total', formatMoney(total), 'ol-sauna-heater__summary-row--total'));
        }
      }

      if (addButton) {
        var canBuy = Boolean(heater) && Boolean(currentVariant && currentVariant.available);
        addButton.disabled = !canBuy;
      }
    }

    Array.prototype.forEach.call(inputs, function (input) {
      input.addEventListener('change', render);
    });

    document.addEventListener('venue:variant:updated', function (event) {
      var detail = event.detail || {};
      if (!detail.product || String(detail.product.id) !== String(productId)) return;
      currentVariant = detail.variant || null;
      render();
    });

    render();
    keepLifestyleFirst(productId);
  }

  /*
    The theme moves the gallery to the selected variant's image as the page loads,
    which skips the lifestyle photo in position 1. On first load only, put the
    gallery back on image 1. Variant changes by the shopper still move the gallery,
    and a link that names a variant (?variant=) keeps the theme's behaviour.
  */
  function keepLifestyleFirst(productId) {
    if (/[?&]variant=/.test(window.location.search)) return;
    var scope = document.querySelector('.js-product-' + productId);
    var slider = scope && scope.querySelector('.js-product-slider');
    if (!slider || !window.jQuery) return;

    var touched = false;
    var markTouched = function () { touched = true; };
    scope.addEventListener('pointerdown', markTouched, { once: true, capture: true });
    scope.addEventListener('keydown', markTouched, { once: true, capture: true });

    // The theme's jump can land at any point while the page is still loading,
    // so for the first few seconds (until the shopper touches the page) put the
    // gallery back on image 1 whenever it has moved.
    var started = Date.now();
    var readyAt = 0;
    var timer = setInterval(function () {
      var $slider = window.jQuery(slider);
      var now = Date.now();
      // Stop once the shopper interacts, 4s after the gallery is ready, or 20s after load.
      if (touched || now - started > 20000 || (readyAt && now - readyAt > 4000)) { clearInterval(timer); return; }
      if (!$slider.hasClass('slick-initialized')) return;
      if (!readyAt) readyAt = now;
      if ($slider.slick('slickCurrentSlide') !== 0) $slider.slick('slickGoTo', 0, true);
    }, 100);
  }

  function init() {
    var pickers = document.querySelectorAll('[data-ol-sauna-heater-picker]');
    Array.prototype.forEach.call(pickers, setupPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
